import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAsbest = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M9.71 29V15.85a10.67 10.67 0 0 1 21.33 0V29"
    />
    <path
      fill="#FF7842"
      d="m7.413 27.628 3.175-3.175 5.868 5.869-3.174 3.175a1.49 1.49 0 0 1-2.108 0l-3.768-3.77a1.49 1.49 0 0 1 0-2.106zM29.906 24.873l2.828 2.828a1.4 1.4 0 0 1 0 1.98l-3.896 3.896a1.4 1.4 0 0 1-1.98 0l-2.829-2.828 5.87-5.87zM14.27 22.97a5.93 5.93 0 1 0 0-11.86 5.93 5.93 0 0 0 0 11.86"
    />
    <path
      fill="#FF7842"
      d="M26.12 22.97a5.93 5.93 0 1 0 0-11.86 5.93 5.93 0 0 0 0 11.86"
    />
    <path
      fill="#FFBFA5"
      d="M26.12 12.3H14.4a4.83 4.83 0 0 0-4.87 4.51 4.74 4.74 0 0 0 9.24 1.72 1.5 1.5 0 0 1 1.42-1 1.49 1.49 0 0 1 1.43 1 4.74 4.74 0 1 0 4.5-6.24z"
    />
    <path
      fill="#fff"
      d="M20.06 36a5.98 5.98 0 1 0 0-11.96 5.98 5.98 0 0 0 0 11.96"
    />
    <path
      fill="#fff"
      d="M20.06 36a5.98 5.98 0 1 0 0-11.96 5.98 5.98 0 0 0 0 11.96"
    />
    <path
      fill="#FF7842"
      d="M20.06 34a3.98 3.98 0 1 0 0-7.96 3.98 3.98 0 0 0 0 7.96"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20.69 4v5.93h-1V4zM11.11 17.17a4.09 4.09 0 0 0 4.099 4.09l.002 1a5.09 5.09 0 0 1-5.101-5.09z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAsbest);

export default ForwardRef;
